<template>
    <div class="row left-align vert-offset-top-1">
    <div v-show="component == ''" class="col s12">
    <div class="card grey lighten-4 col s12 l10 offset-l1" >
        <div class="card-content col s12" >
            <div class="card-title col s12 margin-top-half margin-bottom-half vert-offset-top-1 padding-top-half">
                <h4 class="center">Which Outlet?</h4>
            </div>
            <div class="row " >
                <div class="col s12 vert-offset-top-1 padding-top-1 grey-border border-top-1 border-lighten-2">
                    <nav class="vert-offset-bottom-1">
                        <div class="nav-wrapper grey lighten-2">
                            <form @submit.prevent="">
                                <div class="input-field">
                                    <input id="search" type="search" v-model="filter" autocomplete="off" placeholder="Enter your search key here" required>
                                    <label class="label-icon" for="search"><i class="material-icons black-text">search</i></label>
                                    <button @click="search" class="btn grey darken-2 white-text margin-left-half margin-right-half center submitbtn right">Search</button>
                                </div>

                            </form>

                        </div>
                    </nav>
                    <div v-for="(result, index) in results" class="result col s12 padding-top-half padding-bottom-half" @click="select_outlet(index)" :key="result.key">
                        <button class="btn-large grey lighten-1 black-text col s12">{{result.name}}</button>
                    </div>
                    <div v-show="search_completed == true && (typeof results === 'undefined' || results === null || results.length <= 0)" class="col s12 padding-top-half padding-bottom-half">
                        <div class="row vert-offset-top-half">
                            <h6>There was not outlet matching your search key.</h6>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
   </div>
        <component v-bind:is="component"></component>

 </div>

</template>

<script>

   import TakePic from "@/components/TakePic"
   import http from "../http-common"
export default {

name:"SearchBarSelect",
components:{
    'TakePic':TakePic
},
    data(){
     return {
         search_completed: false,
         enableDisable: false,
         filter:"",
         errors: [],
         component: "",
         items:null,
         search_triggered: false,
         outlets: [],
         results:[],
         loading: false,
         term:'',
         selected_outlet:null,
         noResults:false,
         searching:false,
         stage:1

     };

    },
   methods:{
       getOutlets: function(keyword) {

           this.search_completed = false;
           this.$store.dispatch("START_PROCESSING");
           return new Promise(resolve => {
               http({
                   url: "/outlets/search",
                   data : {
                       name : keyword,
                   },
                   method: "POST",
                   timeout: 30000 })
                   .then(resp => {

                       this.search_completed = true;
                       //console.log("outlets:" + JSON.stringify(resp.data));
                       this.results = resp.data.data;
                       this.$store.dispatch("STOP_PROCESSING");

                       resolve(resp);
                   })
                   .catch(response => {
                       //console.log("ErrResponse: " + JSON.stringify(response));
                       this.$store.dispatch("STOP_PROCESSING");
                       this.$store.dispatch("GET_MESSAGES", response.data.messages);

                   });
           });
       },
     validate: function (e) {

         this.errors = [];

         if (!this.input) {
             this.errors.push('input is required.');
         }

         e.preventDefault();
         },
       async fetchData() {
           return new Promise((resolve) => {
               setTimeout(() => {
                   this.items =
                   resolve()
               }, 3000)
           })
       },
       search() {


          /* if (!this.filter) {
               return this.outlets
           }
            this.results = this.outlets.filter(item => item.store_name.toLowerCase().startsWith(this.filter.toLowerCase()) || item.branch.toLowerCase().startsWith(this.filter.toLowerCase()))*/
          this.getOutlets(this.filter);
       },
       select_outlet(index){

           this.selected_outlet = this.results[index];
           this.$store.dispatch('SET_SELECTED_OUTLET',this.selected_outlet.key);
           this.component = 'TakePic';


       }

     },
    mounted() {
        this.loading = true

        this.fetchData().then(() => {
            this.loading = false
        })
    },

   computed:{
       searchoutlets:function() {
           return this.LiqourOutlets.filter((Liqouroutlet)=>{
               return this.search.toLowerCase().split('').every(v =>Liqouroutlet.Key.toLowerCase().includes(v));
           });
       },
       isDisabled: function() {
           return !this.input;
       },

   },
    created (){

    },
    watch:{
        search(){

        }
    }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
